import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomIdDirective } from './custom-id.directive';
import { MatAutocompleteInfiniteScrollDirective } from './mat-autocomplete-infinite-scroll.directive';
import { ConfirmRedirectDirective } from './confirm-redirect.directive';
import { ConcreteBaseScrollingComponent } from '../_shared-components/base-scrolling-component/concrete-base-scrolling-component';
import { NumberOnlyInputDirective } from './number-only-input-directive/number-only-input-directive';

@NgModule({
  declarations: [
    CustomIdDirective,
    MatAutocompleteInfiniteScrollDirective,
    ConfirmRedirectDirective,
    NumberOnlyInputDirective
  ],
  imports: [
    CommonModule
  ],
  exports:[
    CustomIdDirective,
    MatAutocompleteInfiniteScrollDirective,
    ConfirmRedirectDirective,
    NumberOnlyInputDirective
  ],
  providers: [ConcreteBaseScrollingComponent]
})
export class DirectivesModule { }
